import theme from '../../theme';

const styles = {
  formControl: {
    width: '170px',
    backgroundColor: theme.palette.common.white,
    mb: '10px',
  },
};

export default styles;
